import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { FC, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { FormProvider, useForm } from "react-hook-form";
import { ApiStatus } from "../../utils/api.types";
import LoadingButton from "@mui/lab/LoadingButton";
import AttachmentIcon from '@mui/icons-material/Attachment';
import { IDocFormInputs } from "../../utils/docAttach.types";
import { addDoc } from "../../store/docAttachThunk";

interface DialogDocAttachFormProps {
  title?: string;
  open: boolean;
  onClose: (k: any) => void;
  onSuccess?: (k: any) => void;
  docAttachId?: string;
  collectionName?: string;
  collectionRefId?: string;
}

const DialogDocAttachForm: FC<DialogDocAttachFormProps> = ({
  title,
  onClose,
  open,
  docAttachId,
  collectionName,
  collectionRefId
}) => {
  const dispatch = useAppDispatch();

  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  // const schema = yup.object().shape({
  //   documentName: yup.string().required("Enter Document Name.")
  //   // file: yup.string().required("This field is required.")
  // });

  const methods = useForm<IDocFormInputs>({
    mode: "onTouched"
    // , resolver: yupResolver(schema)
  });
  const { status } = useAppSelector(state => state.docAttach);

  const handleSelectFile = (e: any) => {
    setSelectedFile(e.target.files[0]);
  };

  const createDocAttach = async (e: any) => {
    console.log(e);
    const form: any = new FormData();
    if(collectionName && collectionRefId && collectionName != '' ) {
      form.append('collectionName', collectionName);
      form.append('collectionRefId', collectionRefId);
    }
    if(e.documentName) {
      form.append('documentName', e.documentName);
    }
    form.append('attachment', selectedFile as any);
    console.log(form)
    const docResponse: any = await dispatch(addDoc(form));

    if (!docResponse.error) {
      onClose(true);
    }
  };

  const onSubmit = (e: any) => {
    createDocAttach(e);
  };

  return (
    <div className="drawer-form-container">
      <FormProvider {...methods}>
        <Box
          sx={{ display: "flex", flexDirection: "column", height: "100vh", padding: "10px 0 10px 10px" }}
          component="form"
          onSubmit={methods.handleSubmit(onSubmit)}
          noValidate
        >
          <DialogTitle
            sx={{
              height: "0px",
              mt: 1,
              mb: 1,
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography variant="h5">
                Attach Document
              </Typography>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Grid
              container
              justifyContent="center"
              spacing={2}
              rowSpacing={-2}
            >
              <Grid item xs={12} md={12} sm={12} lg={12} sx={{ mt: "10px" }}>
                <h5 className='c-label2'>Documement Name *</h5>
                  <TextField 
                    className='c-text-field-4'
                    {...methods.register("documentName")}
                    variant="standard" 
                    sx={{width:'100%',mt:0.5,borderRadius:'5px !important'}} 
                    size='small'
                    InputProps={{
                    disableUnderline: true,
                    }}
                  />
                  <p style={{color: "#c33b3b"}}>{methods.formState.errors.documentName?.message ?? ""}</p>
              </Grid>
              <Grid item xs={12} md={12} sm={12} lg={12} sx={{ mt: "10px" }}>
                {selectedFile && <div>{selectedFile.name}</div>}
                <Button variant="outlined" component="label">
                  <AttachmentIcon sx={{ mr: '10px', mb: '2px' }} /> Select file
                  <input hidden accept="file/*" multiple type="file" onChange={handleSelectFile} name="file"
                    required id="file" />
                </Button>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ height: "20px", mb: 2}}>
            <Grid container gap='0' sx={{ mr: '10px', pt: '0px' }}>
              <Grid item xs={12} md={12} sm={12} lg={12} display="flex" justifyContent="flex-end" >
                <Button
                  style={{ marginRight: '10px' }}
                  variant="outlined"
                  onClick={() => {
                    methods.reset();
                    onClose(false);
                  }}
                >
                  Cancel
                </Button>
                <LoadingButton
                  type="submit"
                  // disabled={!methods.formState.isValid}
                  loading={status === ApiStatus.LOADING}
                  onSubmit={onSubmit}
                  variant="contained"
                >
                  {docAttachId ? 'Update' : 'Save'}
                </LoadingButton>
              </Grid>
            </Grid>
          </DialogActions>
        </Box>
      </FormProvider>
    </div>
  );
};

export default DialogDocAttachForm;